import config from '@config';
import merge from 'lodash/merge';

const fontFamily = 'FedraSansStd-medium';

const commonLangStyle = ({ lang, ...props }) => {
  const isIndian = config.indianLang.indexOf(lang) > -1;
  const styleObj = {
    expertText: {
      fontSize: '1.5rem',
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontWeight: 500,
      lineHeight: '24px',
    },
    walksText: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: '48px',
      lineHeight: '68px',
      color: '#fff',
      fontWeight: 500,
      letterSpacing: '-0.48px',
    },
    stepsText: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: '24px',
      lineHeight: '32px',
      color: '#fff',
      fontWeight: 500,
      letterSpacing: '-0.24px',
    },
    fitText: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: '18px',
      lineHeight: '28px',
      color: 'rgba(255, 255, 255, 0.40)',
      fontWeight: 500,
      letterSpacing: '-0.18px',
    },
    addingText: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: '24px',
      lineHeight: '1.9rem',
      fontStyle: 'normal',
      fontWeight: 500,
    },
    meditateText: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: { md: '84px', base: '48px' },
      lineHeight: { md: '92px', base: '52px' },
      fontStyle: 'normal',
      fontWeight: 500,
    },
    minutesText: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: { md: '64px', base: '36px' },
      lineHeight: { md: '92px', base: '52px' },
      fontStyle: 'normal',
      fontWeight: 500,
    },
    shapeText: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: { md: '20px', base: '14px' },
      lineHeight: { md: '23px', base: '16px' },
      fontStyle: 'normal',
    },
    scienceText: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: '16px',
      lineHeight: '22px',
      fontStyle: 'normal',
      letterSpacing: '-0.24px',
      fontWeight: 400,
    },
    scienceImageText: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: '14px',
      lineHeight: '20px',
      fontStyle: 'normal',
      letterSpacing: '-0.24px',
      fontWeight: 400,
    },
    buttonText: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: '18px',
      textTransform: 'uppercase',
      letterSpacing: '-0.54px',
      fontWeight: 600,
      fontStyle: 'normal',
    },
  };

  const finalObj = merge(styleObj, { ...props });
  return finalObj;
};

const ShowScienceSt = {
  en: commonLangStyle({ lang: 'en' }),
  bn: commonLangStyle({ lang: 'bn' }),
  hi: commonLangStyle({
    lang: 'hi',
  }),
  te: commonLangStyle({ lang: 'te' }),
  kn: commonLangStyle({ lang: 'kn' }),
  gu: commonLangStyle({ lang: 'gu' }),
  mr: commonLangStyle({ lang: 'mr' }),
  ml: commonLangStyle({ lang: 'ml' }),
  'zh-tw': commonLangStyle({ lang: 'zh-tw' }),
  zh: commonLangStyle({ lang: 'zh' }),
  it: commonLangStyle({ lang: 'it' }),
  fr: commonLangStyle({ lang: 'fr' }),
  de: commonLangStyle({ lang: 'de' }),
  es: commonLangStyle({ lang: 'es' }),
  ru: commonLangStyle({
    lang: 'ru',
    buttonText: {
      fontSize: '12px',
    },
  }),
  ta: commonLangStyle({
    lang: 'ta',
    buttonText: {
      fontFamily: config.momLangFont['ta'],
      fontSize: '16px',
      textTransform: 'uppercase',
      letterSpacing: '-0.54px',
      fontWeight: 600,
      fontStyle: 'normal',
    },
  }),
  cn: commonLangStyle({ lang: 'cn' }),
  ar: commonLangStyle({
    lang: 'ar',
  }),
  id: commonLangStyle({ lang: 'id' }),
};
export default ShowScienceSt;
